/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyInvite } from './CompanyInvite';
import {
    CompanyInviteFromJSON,
    CompanyInviteFromJSONTyped,
    CompanyInviteToJSON,
    CompanyInviteToJSONTyped,
} from './CompanyInvite';

/**
 * Result of sending a company invitation
 * @export
 * @interface InviteMemberResponse
 */
export interface InviteMemberResponse {
    /**
     * 
     * @type {CompanyInvite}
     * @memberof InviteMemberResponse
     */
    invite: CompanyInvite;
    /**
     * 
     * @type {string}
     * @memberof InviteMemberResponse
     */
    message: string;
}

/**
 * Check if a given object implements the InviteMemberResponse interface.
 */
export function instanceOfInviteMemberResponse(value: object): value is InviteMemberResponse {
    if (!('invite' in value) || value['invite'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function InviteMemberResponseFromJSON(json: any): InviteMemberResponse {
    return InviteMemberResponseFromJSONTyped(json, false);
}

export function InviteMemberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteMemberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invite': CompanyInviteFromJSON(json['invite']),
        'message': json['message'],
    };
}

export function InviteMemberResponseToJSON(json: any): InviteMemberResponse {
    return InviteMemberResponseToJSONTyped(json, false);
}

export function InviteMemberResponseToJSONTyped(value?: InviteMemberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invite': CompanyInviteToJSON(value['invite']),
        'message': value['message'],
    };
}

